import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import HomePage from "./pages/home-page";
import About from "./pages/about";
import Contact from "./pages/contact";
import QuestionPage from "./pages/questionpage";
import Login from "./pages/login";
import PartyManager from "./pages/partymanager";
import Profile from "./pages/profile";
import Gallery from "./pages/gallery";
import Gallery2 from "./pages/gallery2";
import Gallery3 from "./pages/gallery3";
import ProtectedRoute from "./components/ProtectedRoute";
import Loader from "./components/loader";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import MobileApp from "./pages/mobileapp";
import Register from "./pages/register";
import { ToastContainer } from "react-toastify";
import Members from "./pages/member";
import "react-toastify/dist/ReactToastify.css";
import MobileGallery from "./pages/mobilegallery";
import ContactUs from "./pages/mobilecontact";
import VideoUpload from "./pages/videoupload";
import VideoGallery from "./pages/videogallery";
import AppDownload from "./pages/app-download";
import Location from "./pages/location";
import BarChartPage from "./pages/mobilecharts";
import MessagePage from "./pages/MessagePage";

function PageLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [location]);

  return loading ? <Loader /> : null;
}

// ✅ NEW wrapper component
function AppContent() {
  const location = useLocation();

  // 🎯 hide navbar/footer on mobiletvk
  const hideLayoutRoutes = ["/mobiletvk", "/members", "/mobilegallery", "/mobilecontact", "/videosupload","/videos", "/appdownload", "/location", "/mobilecharts", "/send-noti"];
  const hideLayout = hideLayoutRoutes.includes(location.pathname);
    

  return (
    <div className="app-wrapper">
      {!hideLayout && <Navbar />}

      <PageLoader />

      <div className="page-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/questionpage" element={<QuestionPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery2" element={<Gallery2 />} />
          <Route path="/gallery3" element={<Gallery3 />} />
          <Route path="/mobiletvk" element={<MobileApp />} />
          <Route path="/mobilegallery" element={<MobileGallery />} />
          <Route path="/mobilecontact" element={<ContactUs />} />
          <Route path="/members" element={<Members />} />
          <Route path="/videosupload" element={<VideoUpload /> } />
          <Route path="/videos" element={<VideoGallery />} />
          <Route path="/appdownload" element={<AppDownload />} />
          <Route path="/location" element={<Location />} />
          <Route path="/mobilecharts" element={<BarChartPage />}/>
          <Route path="/send-noti" element={<MessagePage  />}/>
          <Route
            path="/manager"
            element={
              <ProtectedRoute>
                <PartyManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>

      {!hideLayout && <Footer />}

      <ToastContainer position="top-center" autoClose={3000} theme="colored" />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;